import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type Store = {
    organizacao: 'dia' | 'jornada'
    setOrganizar: (organizar: 'dia' | 'jornada') => void
}

export const useDigitacaoStore = create<Store>()(
    persist(
        set => ({
            organizacao: 'dia',
            setOrganizar: (organizar: 'dia' | 'jornada') =>
                set(store => ({
                    ...store,
                    organizacao: organizar,
                })),
        }),
        {
            name: 'digitacao-store',
            version: 1,
        },
    ),
)
